import './SmallButton.scss';

import React from 'react';
import classnames from 'classnames';

interface Props {
  children: React.ReactNode;
  selected?: boolean;
  onClick(event: React.SyntheticEvent<HTMLButtonElement>): void;
}

const SmallButton: React.FC<Props> = (props) => {
  const { children, selected, onClick } = props;

  return (
    <button
      className={classnames('SmallButton', {
        'SmallButton--selected': selected
      })}
      onClick={onClick}
    >
      {children}
    </button>
  );
};

export default SmallButton;
